<template>
  <b-row>

    <b-col cols="12" lg="12">
      <b-card>
        <b-tabs content-class="pt-1">
          <b-tab active title="Officer debt">
            <OfficerDepartment />
          </b-tab>
          <b-tab title="Kabag Dept">
            <KabagDepartment />
          </b-tab>
          <b-tab title="Management">
            <Management />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BRow, BCol, BTabs, BTab } from "bootstrap-vue";

import OfficerDepartment from "@/components/Management/OfficerDepartment.vue";
import KabagDepartment from "@/components/Management/KabagDepartment.vue";
import Management from "@/components/Management/Management.vue";

export default {
  title() {
    return `Master Departemen`;
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTabs,
    BTab,
    OfficerDepartment,
    KabagDepartment,
    Management,
  },
  data() {
    return {
      result: {},
      isLoading: false,
      filter: {
        user_uuid: "",
        page: 1,
      },
    };
  },
  created() {
    // this.loadData();
  },
  methods: {
    loadData() {
      this.$http.get(`/admin/users/${this.id}`).then((response) => {
        this.userData = response.data.data;
      });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      queryParams.user_uuid = this.id;

      this.$http
        .get(`/admin/wallet/${this.typeSlug}`, {
          params: queryParams,
        })
        .then((response) => {
          this.result = response.data.data;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
